import { NetworkBasePopUp } from '../../NetworkBasePopUp';
import { translateFn } from '../../../../../utils/translator.helper';
import { GzDialog } from '../../../../../ui/gzDialog/component/GzDialog';
import {
  GoldenImageAssignation,
  GzGoldenImageAssignationWebComponent,
} from '../component/GzGoldenImageAssignationWebComponent';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ConsoleRequest, DataProviderType } from '../../../../../utils/request';

export const AFTER_MARK_EVENT_NAME = 'afterMarkGoldenImage';

export class MarkGoldenImagePopUp extends NetworkBasePopUp<GzGoldenImageAssignationWebComponent> {
  protected customEventNameAfterConfirm = AFTER_MARK_EVENT_NAME;
  protected title = translateFn('Mark as Golden Image');
  protected extraDialogConfigs: Partial<GzDialog> = { isWindow: false };

  protected customSetup() {
    const target = this.getSelectedTarget();
    if (!target) {
      return;
    }

    this.popUpContent = new GzGoldenImageAssignationWebComponent();
    this.popUpContent.type = GoldenImageAssignation.ASSIGN;
    this.popUpContent.endpointName = target.name;
    this.popUpContent.companyName = target.company?.name || '';
  }

  protected async handleConfirmButtonClicked(event: CustomEvent): Promise<void> {
    const target = this.getSelectedTarget();
    if (!target) {
      return;
    }

    const payload = {
      protectedEntityId: target._id,
    };

    try {
      await ConsoleRequest.createRequest({
        dataProviderType: DataProviderType.ENDPOINTS,
        endpoint: 'UnifiedEndpoints',
        method: 'markAsGoldenImage',
        payload: payload,
      });

      this.showCustomToast(translateFn('Endpoint successfully marked as a Golden Image.'));
    } catch (e) {
      this.showErrorToastNotification(translateFn('Failed to mark the endpoint as a Golden Image.'));
    }
  }

  private getSelectedTarget(): ProtectedEntity | undefined {
    if (!this.data.targets || this.data.targets.length !== 1) {
      console.error('Could not open dialog. Targets are not defined or received multiple targets.');
      return undefined;
    }

    return this.data.targets[0];
  }
}
